/**
 * defa.collections.warmupStates
 * A Collection of WarmupState
 * @version 1.0.0
 */
import WarmupState from 'scripts/defa/control/warmup-state/model-warmupstate';

const WarmupStates = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : WarmupState,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default WarmupStates;